<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__organisation_title')}}</h4>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__founding_docs')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__age_of_org')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.founding_docs === row.value}" v-for="(row, index) in tableFoundingDocs" :key="index">
                <td>
                  <radio name="model.founding_docs"
                         :value="row.value"
                         v-model="EvaluationForm.model.founding_docs"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.founding_docs}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__note')}}</p>
              <p class="font-weight-bold">{{$t('medium_grant_ev.diligence__note_msg')}}</p>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_diligence_founding" :comments="EvaluationForm.model.comments_diligence_founding"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__governance_title')}}</h4>
            <div>
              <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__governing_body')}}</h5>
              <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5" :key="EvaluationForm.model.governing_body">
                <tr>
                  <th></th>
                  <th>{{$t('medium_grant_ev.general__score')}}</th>
                  <th>{{$t('medium_grant_ev.diligence__governing_body_table')}}</th>
                  <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
                </tr>
                <tr class="text-center" :class="{'selected-row': EvaluationForm.model.governing_body === row.value}" v-for="(row, index) in tableGoverningBody" :key="index">
                  <td>
                    <radio name="model.governing_body"
                           :value="row.value"
                           v-model="EvaluationForm.model.governing_body"
                    >
                    </radio>
                  </td>
                  <td>{{row.value}}</td>
                  <td>{{row.text}}</td>
                  <td v-if="index === 0" rowspan="4" class="force-bg-white">
                    <h1 class="m-0 p-0">{{EvaluationForm.model.governing_body}}</h1>
                  </td>
                </tr>
              </table>
              <div>
                <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_governing_body" :comments="EvaluationForm.model.comments_governing_body"></comment-box>
              </div>
            </div>

            <div class="mt-5 pt-3">
              <h5 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__is_the_governing_body')}}</h5>
              <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
                <tr>
                  <th></th>
                  <th>{{$t('medium_grant_ev.general__score')}}</th>
                  <th>{{$t('medium_grant_ev.diligence__financial_oversight')}}</th>
                  <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
                </tr>
                <tr class="text-center" :class="{'selected-row': EvaluationForm.model.is_governing_body === row.value}" v-for="(row, index) in tableIsGoverningBody" :key="index">
                  <td>
                    <radio name="model.is_governing_body"
                           :value="row.value"
                           v-model="EvaluationForm.model.is_governing_body"
                    >
                    </radio>
                  </td>
                  <td>{{row.value}}</td>
                  <td>{{row.text}}</td>
                  <td v-if="index === 0" rowspan="4" class="force-bg-white">
                    <h1 class="m-0 p-0">{{EvaluationForm.model.is_governing_body}}</h1>
                  </td>
                </tr>
              </table>
              <div>
                <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_is_governing_body" :comments="EvaluationForm.model.comments_is_governing_body"></comment-box>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold mb-0">{{$t('medium_grant_ev.diligence__legal_title')}}</h4>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__regulatory_filings')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__governing_body_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.legal === row.value}" v-for="(row, index) in tableLegal" :key="index">
                <td>
                  <radio name="model.legal"
                         :value="row.value"
                         v-model="EvaluationForm.model.legal"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.legal}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_diligence_legal" :comments="EvaluationForm.model.comments_diligence_legal"></comment-box>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tableFoundingDocs: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_more_than_10')},
          {'value': 1, 'text': this.$i18n.t('medium_grant_ev.diligence__table_3_to_10')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__table_1_to_3')},
          {'value': 3, 'text': this.$i18n.t('medium_grant_ev.diligence__table_less_than_1')},
        ],
        tableGoverningBody: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_governance_exists')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_no_governance')},
        ],
        tableIsGoverningBody: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_is_governance_responsible')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_governance_not_responsible')},
        ],
        tableLegal: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_org_fully')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_org_not_uptodate')},
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>